import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { messages } from './messages';
import styles from './styles.module.css';
import { useImportContext } from '../../import-context';
import { useStepDetectiveContext } from '../../step-detective/step-detective-context';

/**
 * @param {object} props
 * @param {boolean} [props.isInitImportBtnDisabled]
 * @returns {React.JSX.Element}
 */
export const ConfigStepFooter = ({ isInitImportBtnDisabled = false }) => {
  const { initRequest, initImport, isGetMappingsLoading, isInitImportLoading } = useImportContext();

  const { goToNext } = useStepDetectiveContext();

  const onInitImportClick = () => {
    initImport(goToNext);
  };

  const isDisabled = !initRequest?.csvFile || isGetMappingsLoading || isInitImportLoading || isInitImportBtnDisabled;

  return (
    <Button className={styles['continue-btn']} disabled={isDisabled} onClick={onInitImportClick} theme='primary'>
      <FormattedMessage {...messages.continueBtn} />
    </Button>
  );
};
